export default "__VITE_ASSET__8e0d19ed__"